import axios from 'axios'
import apiConfig from '../../../config/apiConfig'
import {
  FIRST_MILE,
  MIDDLE_MILE,
  BACKHAUL,
  PICKUP_APPOINTMENT,
} from '../constants/dashboardConstants'
import { createParams } from '@dlm/common'
import { formatSearchFilterDate } from '../../../common/util/dateUtil'

async function getFMLoadSummary(summarySearchFilters) {
  const params = formatToSummaryParams(summarySearchFilters, FIRST_MILE)
  const { data } = await axios.get(`${apiConfig.api.edge}/dashboard`, {
    params: createParams(params),
  })
  return data
}

async function getMMLoadSummary(summarySearchFilters) {
  const params = formatToSummaryParams(summarySearchFilters, MIDDLE_MILE)
  const { data } = await axios.get(`${apiConfig.api.edge}/dashboard`, {
    params: createParams(params),
  })
  return data
}

async function getBackhaulLoadSummary(summarySearchFilters) {
  const params = formatToSummaryParams(summarySearchFilters, BACKHAUL)
  const { data } = await axios.get(`${apiConfig.api.edge}/dashboard`, {
    params: createParams(params),
  })
  return data
}

async function getPickupLoadSummary(summarySearchFilters) {
  const params = formatToSummaryParams(summarySearchFilters, PICKUP_APPOINTMENT)
  const { data } = await axios.get(`${apiConfig.api.edge}/dashboard`, {
    params: createParams(params),
  })
  return data
}

export function formatToSummaryParams(summarySearchFilters, dashboardView) {
  summarySearchFilters.start_to_date = formatSearchFilterDate(
    summarySearchFilters.start_to_date,
  )
  summarySearchFilters.start_from_date = formatSearchFilterDate(
    summarySearchFilters.start_from_date,
  )
  switch (dashboardView) {
    case FIRST_MILE:
      return {
        ...summarySearchFilters,
        dashboard_type: 'FM_OUTSTANDING_LOADS',
      }
    case MIDDLE_MILE:
      return {
        ...summarySearchFilters,
        dashboard_type: 'MM_GM_DASHBOARD',
      }
    case BACKHAUL:
      return {
        ...summarySearchFilters,
        dashboard_type: 'GM_BACKHAUL_DASHBOARD',
      }
    case PICKUP_APPOINTMENT:
      return {
        ...summarySearchFilters,
        dashboard_type: 'PICKUP_APPOINTMENT_DASHBOARD',
      }
    default:
      return {}
  }
}

export default {
  getFMLoadSummary,
  getMMLoadSummary,
  getBackhaulLoadSummary,
  getPickupLoadSummary,
}
